import axios from 'axios';
import { userConstants } from '../../onboarding/user.constants';
import { store } from '../../app/store';
import { ApiError, CANCELED_CODE } from './apiError';

export const handleResponse = (axiosPromise) => {
  // Taken in the caller's frame. The catch below runs in a microtask, by which
  // point the action that made the request is off the stack, so this is the
  // only place a stack still names the caller.
  const callSite = new Error();

  return axiosPromise
    .then(response => response.data)
    .catch((error) => {
      const config = (error && error.config) || {};
      const meta = {
        method: config.method,
        url: config.url,
        stack: callSite.stack,
        // Tells a timeout or a cancellation apart from being offline.
        errorCode: axios.isCancel(error) ? CANCELED_CODE : error && error.code
      };

      if (!error || !error.response) {
        // Network or unexpected error; the request never produced a status.
        return Promise.reject(new ApiError('Network error', { ...meta, status: 0 }));
      }
      // Server error
      const code = error.response.status;
      const responseData = error.response.data;

      if (code === 401) { // Unauthorized, so forcibly logging out.
        store.dispatch({ type: userConstants.GET_USER_FAILURE, error });
      }

      const isObject = responseData && typeof responseData === 'object';

      return Promise.reject(new ApiError(
        isObject ? responseData.message : String(responseData || 'Request failed'),
        { ...meta, status: code, data: isObject ? responseData : null }
      ));
    });
};
